export default __webpack_public_path__ + "static/media/SWT1370.34I-41058_-24523_0.6ff81be3.jpg";